import { render, staticRenderFns } from "./FeaturesPageFeaturePanel.vue?vue&type=template&id=e81742ca&scoped=true&"
import script from "./FeaturesPageFeaturePanel.vue?vue&type=script&lang=js&"
export * from "./FeaturesPageFeaturePanel.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesPageFeaturePanel.vue?vue&type=style&index=0&id=e81742ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81742ca",
  null
  
)

export default component.exports